import Carousel from '../components/Carousel'
import Contact from '../components/Contact'
import Feedbacks from '../components/Feedbacks'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import IdeaSectionAbout from '../section/IdeaSectionAbout'
import ModerLogoHero from '../section/ModerLogoHero'
import React from 'react'
import LogoPortfolio from '../components/LogoPortfolio'
import PartnersLogos from '../components/PartnersLogos'
import { Helmet } from 'react-helmet';
import IdeaLogoDesignSect from '../section/IdeaLogoDesignSect'


function ModernLogoDesign() {
  return (
    <div className="relative z-0 bg-[#060816]">
      <Helmet>
        <title>Modern Logo Design - The Designsinc.</title>
      </Helmet>
      
    <div>
      <Navbar />
      <div>
        {/** About Section */}
       <ModerLogoHero />
        {/**Slider logos company */}
        <PartnersLogos />

        {/**idea section and btns */}
        <IdeaLogoDesignSect />

        {/** Logo Portfolios */}
        <h2 className="text-center p-3 font-bold text-[36px] text-white">Logo Portfolio</h2>
        <LogoPortfolio />

        {/** Testimonials */}
        <div className="">
        <Feedbacks  />
        </div>
        {/** contact section */}
        <div className='relative z-0'>
      <Contact />
  
    </div>
      </div>
    </div>

    <Footer />
  </div>
  )
}

export default ModernLogoDesign